module.exports = __webpack_public_path__ + "img/fireLogo.9cabfedb.png";